import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Setor} from '../../comum/modelos/setor';
import {SetorService} from '../setor.service';
import {ComumService} from '../../comum/comum.service';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-setores-cadastro',
  templateUrl: './cadastro-setor.component.html',
  styleUrls: ['./cadastro-setor.component.css']
})
export class CadastroSetorComponent implements OnInit {

  setor: Setor;

  MODO: string;
  CADASTRAR = 'Cadastrar';
  ATUALIZAR = 'Atualizar';
  public loading = false;
  public statusCode: number;

  constructor(
    private _setorService: SetorService,
    private _comumService: ComumService,
    private _activatedRoute: ActivatedRoute,
    private router: Router,
    private _authService: AuthService) {
    this.setor = new Setor();
  }

  ngOnInit() {
    this.obterSetorPorId(this._activatedRoute.snapshot.params['id']);
  }

  obterSetorPorId(id: number): void {
    this.loading = true;
    if (id !== undefined) {
      const self = this;
      this._setorService.obterSetorPorIdHttp(id)
        .subscribe((setor: Setor) => {
          self.setor = setor;
          self.MODO = self.ATUALIZAR;
          self.loading = false;
        });
    } else {
      this.MODO = this.CADASTRAR;
      this.loading = false;
    }
  }

  onSubmit(): void {

    const self = this;

    if (this.MODO === this.CADASTRAR) {
      this._setorService.cadastrarSetorHttp(this.setor)
        .subscribe(response => {
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.cadastro = true;
          this.router.navigate(['listar-setores/']);
        }, errorCode => {
          this.statusCode = errorCode;
          this.loading = false;
        });
    } else {
      this._setorService.atualizarSetorHttp(this.setor)
        .subscribe(response => {
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.cadastro = true;
          self.router.navigate(['listar-setores/']);
        }, errorCode => {
          this.statusCode = errorCode;
          this.loading = false;
        });
    }

  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/setor/cadastro-setor/cadastro-setor.component.ts